import React from "react";
import { ICONS, type IconName } from "@/icons/registry";

export default function Icon({
  name,
  size = 16,
  className = "",
  title,
  decorative = !title,
  ...rest
}: {
  name: IconName;
  size?: number;
  className?: string;
  title?: string;
  decorative?: boolean;
} & React.SVGProps<SVGSVGElement>) {
  const Cmp = ICONS[name];
  if (!Cmp) return null;
  return (
    <Cmp
      width={size}
      height={size}
      className={className}
      aria-hidden={decorative ? true : undefined}
      role={decorative ? undefined : "img"}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
    </Cmp>
  );
}
